import React, { useContext } from 'react';

import { Form, Field } from 'react-final-form';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import FormTitle from 'components/shared/Typography/FormTitle';

import { CustomFontsContext } from '../context';
import { useFontsForm } from './useFontsForm';

function FontsForm() {
  const { handleCloseFontsForm, getFonts } = useContext(CustomFontsContext);
  const { submit, validate, acceptFonts } = useFontsForm({ getFonts, handleCloseFontsForm });
  return (
    <>
      <FormTitle center>Upload Font</FormTitle>

      <Form
        onSubmit={submit}
        initialValues={{}}
        validate={validate}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Field component={FormGroupAdapter} name="countries" type="inputGroup">
              <Field component={FormGroupAdapter} name="file" label="File" type="file" accept={acceptFonts.join(',')} />
              <Field component={FormGroupAdapter} name="fontFamily" label="Font Family*" />
            </Field>

            <Field component={FormGroupAdapter} name="countries" type="inputGroup">
              <Field component={FormGroupAdapter} name="fontStyle" label="Font Style*" />
              <Field component={FormGroupAdapter} name="fontWeight" label="Font Weight*" />
            </Field>

            <FormActions isSpaceBetween>
              <Button htmlType="button" type="default" disabled={submitting} onClick={handleCloseFontsForm}>
                Cancel
              </Button>
              <Button htmlType="submit" disabled={submitting}>
                Submit
              </Button>
            </FormActions>

            {/* <pre style={{ fontSize: '16px' }}>{JSON.stringify(values, 0, 2)}</pre> */}
          </form>
        )}
      />
    </>
  );
}

export default FontsForm;
